/**
 * Converts a string from PascalCase or snake_case to camelCase.
 * Mirrors enrollment-platform-service convert-keys-to-camel-case.ts.
 */
export function pascalToCamelCase(key) {
  if (!key) return ''
  if (key.includes('_')) {
    const leadingUnderscores = /^_+/.exec(key)?.[0] ?? ''
    const rest = key.slice(leadingUnderscores.length)
    if (rest.length === 0) return key
    const converted = rest
      .toLowerCase()
      .replace(/_([a-z0-9])/g, (_, char) => char.toUpperCase())
    return leadingUnderscores + converted
  }
  const acronymMatch = key.match(/^([A-Z]{2,})(?=[A-Z][a-z]|$)/)
  if (acronymMatch) {
    return acronymMatch[1].toLowerCase() + key.slice(acronymMatch[1].length)
  }
  return key.charAt(0).toLowerCase() + key.slice(1)
}

export function convertKeysToCamelCase(obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToCamelCase(item))
  }

  if (typeof obj === 'object') {
    if (
      obj instanceof Date ||
      typeof obj.toISOString === 'function'
    ) {
      return obj.toISOString()
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
      acc[pascalToCamelCase(key)] = convertKeysToCamelCase(value)
      return acc
    }, {})
  }

  return obj
}
